import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import {
    Observable,
    of,
} from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../environments/environment";
// @ts-ignore
// import data from "../assets/default-translate.json";

export class CustomTranslateLoaderService implements TranslateLoader {

    constructor(private http: HttpClient) {
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getTranslation(lang: string): Observable<Record<string, string>> {
        // const defaultTranslations: Record<string, string> = JSON.parse(JSON.stringify(data));
        return this.http.get<Record<string, string>>(`${environment.portalUrl}translations/${lang}`).pipe(
            // return this.http.get<Record<string, string>>(`http://localhost:4000/assets/i18n/en.json`).pipe(
            // map((res: Record<string, string>) => {
            //     const defaultKeys: string[] = Object.keys(defaultTranslations);
            //     defaultKeys.forEach((key: string) => {
            //         if (res[key] === "") {
            //             res[key] = defaultTranslations[key];
            //         }
            //     });
            //     // TODO no default values
            //     // return { ...defaultTranslations, ...res };
            //     return { ...res };
            // }),
            catchError(() => of({})),
        );
    }
}
